import * as React from "react"
import { useTranslation } from "react-i18next"

import DeleteButton from "Catalog/Edit/shared/components/CatalogToolbar/DeleteButton"
import NewButton from "Catalog/Edit/shared/components/CatalogToolbar/NewButton"
import CatalogToolbar from "Catalog/shared/components/CatalogToolbar"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { ICharge } from "shared/hubrise/models"

interface ToolbarProps {
  charge?: ICharge
}

const Toolbar = ({ charge }: ToolbarProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  const handleCreate = (name: string): void => {
    const newCharge = editor.charge.add(charge, { name })
    navigate(catalogNavigation.editPath("charge", newCharge.id))
  }

  const handleDelete = (charge: ICharge) => {
    navigate(catalogNavigation.editNextPath("charges"))
    editor.charge.delete(charge.id)
  }

  const commandActions = (
    <>
      <NewButton handleCreate={handleCreate} labelAndTitle={t("toolbar.new.charge")} />
      <DeleteButton item={charge} handleDelete={handleDelete} />
    </>
  )

  return <CatalogToolbar commandActions={commandActions} />
}

export default Toolbar
